import React from "react";
import Markdown from "markdown-to-jsx";

type UseMarkdownProps = {
  rawMarkdown: string;
  isStreaming?: boolean;
};

export function useMarkdown({ rawMarkdown, isStreaming = false }: UseMarkdownProps) {
  // Optional: preprocess markdown (e.g. clean \n)
  const markdown = rawMarkdown?.replace(/\\n/g, "\n");

  return (
    <Markdown
      options={{
        forceBlock: true,
        disableParsingRawHTML: false,
        overrides: {
          a: {
            props: {
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          table: {
            props: {
              style: {
                borderCollapse: "collapse",
                width: "100%",
                margin: "8px 0",
              },
            },
          },
          th: {
            props: {
              style: {
                border: "1px solid #ddd",
                padding: "6px",
                textAlign: "left",
                background: "#f9f9f9",
              },
            },
          },
          td: {
            props: {
              style: {
                border: "1px solid #ddd",
                padding: "6px",
                textAlign: "left",
              },
            },
          },
          hr: {
            props: {
              style: {
                border: "none",
                borderTop: "1px solid #ccc",
                margin: "12px 0",
              },
            },
          },
        },
      }}
      className="markdown-body"
    >
      {markdown}
    </Markdown>
  );
}
 